import {useEffect} from "preact/hooks";

export const useSidebarMenu = props => {
    // Destructured props
    const {isMenuOpen} = props;

    // Effect that will be fired immediately when the component is opened to deactivate the body overflow
    useEffect(() => {
        if (isMenuOpen) {
            // Deactivates the body overflow
            document.body.classList.add("overflow-deactivate");

            return;
        }

        // Reactivates the body overflow
        document.body.classList.remove("overflow-deactivate");
    }, [isMenuOpen])

    return {

    }
}